import __request__ from "routing/request";
export function getFavoriteItems(page = 1, per_page = 5, type) {
  return __request__("GET", "/favorites", null, { "page": page, "per_page": per_page, "type": type }, {
    "Accept": ["application/json"]
  });
}
export function addItemToFavorites(grn) {
  return __request__("PUT", `/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function removeItemFromFavorites(grn) {
  return __request__("DELETE", `/favorites/${grn}`, null, {}, {
    "Accept": ["application/json"]
  });
}
